// extracted by mini-css-extract-plugin
module.exports = {"drawerRoot":"az_sl","drawer":"az_tl","loaderContainer":"az_ul"};